export default __webpack_public_path__ + "static/media/success.f8cd1cfd.svg";